var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 6C10 3.79 8.21 2 6 2C3.79 2 2 3.79 2 6C2 7.24 3.88 10.24 6 12.9C8.12 10.25 10 7.27 10 6ZM0 6C0 2.69 2.69 0 6 0C9.31 0 12 2.69 12 6C12 9.31 6 16 6 16C6 16 0 9.31 0 6ZM7 5H8C8.55 5 9 5.45 9 6C9 6.55 8.55 7 8 7H7V8C7 8.55 6.55 9 6 9C5.45 9 5 8.55 5 8V7H4C3.45 7 3 6.55 3 6C3 5.45 3.45 5 4 5H5V4C5 3.45 5.45 3 6 3C6.55 3 7 3.45 7 4V5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.60d36695fec6596055b144629354014a.svg";
export { ForwardRef as ReactComponent };